// src/pages/Work.js
import React from 'react';
import "../components/work.css";  // Import the CSS file for Work styling

const Work = (props) => {
  return (
    <div className="work-card">
      {/* Display the passed image prop */}
      <img src={props.img} alt="Work Example" className="work-image" />
    </div>
  );
};

export default Work;

